<h2 class="mb-6">Select a task type</h2>

<mat-radio-group [value]="selectedTaskType()" (change)="onTaskTypeChange($event.value)" class="flex flex-col space-y-4">
  @for (taskType of taskTypes; track taskType.value) {
    <mat-radio-button [value]="taskType.value" uiRadioWrapped class="w-full">
      <div class="flex flex-col">
        <span class="font-medium text-base text-text-primary">{{ taskType.label }}</span>
        <span class="text-sm text-text-secondary mt-1 font-normal">{{ taskType.description }}</span>
      </div>
    </mat-radio-button>
  }
</mat-radio-group>
